import {
    blueLinks,
    robotoRegular,
    scarpaGray100,
    scarpaGray25,
    scarpaGray800,
    white,
} from '@habitech/shared';
import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    gap: 4px;
`;

export const LabelRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: ${robotoRegular};
    font-size: 14px;
    font-weight: 400;
    color: ${scarpaGray800};

    .period-label {
        margin: 0;
    }
`;

export const Trigger = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 200px;
    padding: 10px 12px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${scarpaGray800};
    background-color: ${white};
    border: 1px solid ${scarpaGray100};
    border-radius: 8px;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease;

    &:hover {
        border-color: ${scarpaGray100};
    }

    &:focus {
        outline: none;
        border-color: ${blueLinks};
    }
`;

export const DropdownList = styled.div`
    position: absolute;
    z-index: 10;
    top: calc(100% + 4px);
    left: 0;
    min-width: 200px;
    padding: 4px;
    background-color: ${white};
    border: 1px solid ${scarpaGray100};
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(48, 49, 51, 0.12);
`;

export const Option = styled.div<{ $selected?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    font-family: ${robotoRegular};
    font-size: 14px;
    color: ${({ $selected }) => ($selected ? white : scarpaGray800)};
    background-color: ${({ $selected }) => ($selected ? blueLinks : 'transparent')};
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.1s ease, color 0.1s ease;

    &:hover {
        background-color: ${({ $selected }) => ($selected ? blueLinks : scarpaGray25)};
    }
`;
